import { TiledGameObject } from "../../shared/phaserHelpers/HandyTypes";

export class ToolBin extends Phaser.GameObjects.Sprite {
    public boxes: Box[];
    public screwCount: number;
    public boltCount: number;
    public actualX: number;

    constructor(scene: Phaser.Scene, ob: TiledGameObject, texture: string) {
        super(scene, ob.x + ob.width / 2, ob.y + ob.height / 2, texture, 0);

        this.boxes = [];
        this.screwCount = 0;
        this.boltCount = 0;

        // Set as a dropzone
        this.setInteractive();
        this.input.dropZone = true;

        scene.add.existing(this);
    }
}

export class BoxConfig {
    frame: number;
    count: number;
    type: "Screw" | "Bolt";
}

export class Box extends Phaser.GameObjects.Sprite {
    public config: BoxConfig;
    public id: number;
    public type: "Screw" | "Bolt";
    public count: number;
    public pilePosition: Phaser.Geom.Point;
    public inToolBin: boolean;

    constructor(scene: Phaser.Scene, x: number, y: number, config: BoxConfig, id: number) {
        super(scene, x, y, "items", config.frame);
        this.config = config;
        this.id = id;
        this.type = config.type;
        this.count = config.count;
        this.inToolBin = false;

        this.setInteractive();

        this.pilePosition = new Phaser.Geom.Point(x, y);
        this.scene.input.setDraggable(this);

        this.scene.add.existing(this);

    }
}




// WEBPACK FOOTER //
// ./src/games/RocketRepairGame/objects/ToolBin.ts